module.exports = __webpack_public_path__ + "static/Kolumbia-Regular-e410ac740602357f2e6daad6ddbfd91f.woff";